import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

export const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // This hook tells us exactly what page the user is currently on
  const location = useLocation();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) {
        setIsOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  // ─── Dynamic Desktop Styles ───
  const getLinkStyle = (path) => {
    const isActive = location.pathname === path;
    return {
      color: isActive ? "#B07D4F" : "#333",
      textDecoration: "none",
      fontSize: "1.05rem",
      fontWeight: isActive ? "700" : "500",
      padding: "0.5rem 0",
      margin: "0 1rem",
      transition: "all 0.3s ease",
      textTransform: "uppercase",
      letterSpacing: "0.05em",
      borderBottom: isActive ? "2px solid #B07D4F" : "2px solid transparent"
    };
  };

  // ─── Dynamic Mobile Styles ───
  const getMobileLinkStyle = (path) => {
    const isActive = location.pathname === path;
    return {
      width: "100%",
      textAlign: "center",
      padding: "1rem",
      color: isActive ? "#B07D4F" : "#333",
      textDecoration: "none",
      fontSize: "1.1rem",
      fontWeight: isActive ? "700" : "500",
      borderBottom: "1px solid rgba(0,0,0,0.05)",
      backgroundColor: isActive ? "#F7F5F0" : "transparent",
      transition: "all 0.3s ease"
    };
  };

  return (
    <nav style={{
      background: "white",
      boxShadow: "0 2px 15px rgba(0,0,0,0.05)",
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      zIndex: 1000,
      width: "100%",
      height: "auto",
      minHeight: isMobile ? "70px" : "90px",
      display: "flex",
      alignItems: "center"
    }}>
      <div className="container" style={{ width: "100%" }}>
        <div style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%"
        }}>

          {/* ── Logo ── */}
          <Link to="/" style={{ display: "flex", alignItems: "center", textDecoration: "none", color: "inherit" }}>
            <img
              src="/img/Logo.png"
              alt="Softwood Pvt. Ltd."
              style={{ height: isMobile ? "40px" : "50px", marginRight: isMobile ? "10px" : "15px" }}
            />
            <div>
              <h1 style={{
                fontFamily: "'Cormorant Garamond', serif",
                fontSize: isMobile ? "1.5rem" : "2rem",
                fontWeight: "700",
                color: "#0A192F",
                margin: 0,
                lineHeight: "1.2",
                whiteSpace: "nowrap"
              }}>Softwood Pvt. Ltd.</h1>
            </div>
          </Link>

          {/* ── Mobile Hamburger Icon ── */}
          {isMobile && (
            <button
              onClick={toggleMenu}
              style={{
                display: "flex", flexDirection: "column", justifyContent: "space-around",
                width: "2rem", height: "2rem", background: "transparent", border: "none",
                cursor: "pointer", padding: "0", zIndex: "10"
              }}
              aria-label="Toggle menu"
            >
              <div style={{ width: "2rem", height: "0.2rem", background: "#0A192F", borderRadius: "10px", transition: "all 0.3s linear", transformOrigin: "1px", transform: isOpen ? "rotate(45deg)" : "rotate(0)" }} />
              <div style={{ width: "2rem", height: "0.2rem", background: "#0A192F", borderRadius: "10px", transition: "all 0.3s linear", position: "relative", opacity: isOpen ? "0" : "1" }} />
              <div style={{ width: "2rem", height: "0.2rem", background: "#0A192F", borderRadius: "10px", transition: "all 0.3s linear", position: "relative", transformOrigin: "1px", transform: isOpen ? "rotate(-45deg)" : "rotate(0)" }} />
            </button>
          )}

          {/* ── Desktop Navigation Links ── */}
          {!isMobile && (
            <div style={{ display: "flex", alignItems: "center" }}>
              <Link to="/" style={getLinkStyle("/")}>Home</Link>
              <Link to="/about-us" style={getLinkStyle("/about-us")}>About</Link>
              <Link to="/sourcing" style={getLinkStyle("/sourcing")}>Sourcing</Link>
              <Link to="/production" style={getLinkStyle("/production")}>Production</Link>
              <Link to="/careers" style={getLinkStyle("/careers")}>Careers</Link>
              <Link to="/blog" style={getLinkStyle("/blog")}>Blog</Link>
              <Link to="/contact" style={getLinkStyle("/contact")}>Contact</Link>
            </div>
          )}

          {/* ── Mobile Navigation Menu ── */}
          {isMobile && isOpen && (
            <div style={{
              position: "absolute", top: "100%", left: "0", right: "0",
              background: "white", display: "flex", flexDirection: "column",
              alignItems: "center", padding: "0", boxShadow: "0 10px 20px rgba(0,0,0,0.1)", zIndex: "1000",
              borderTop: "1px solid rgba(0,0,0,0.05)"
            }}>
              <Link to="/" onClick={toggleMenu} style={getMobileLinkStyle("/")}>Home</Link>
              <Link to="/about-us" onClick={toggleMenu} style={getMobileLinkStyle("/about-us")}>About Us</Link>
              <Link to="/sourcing" onClick={toggleMenu} style={getMobileLinkStyle("/sourcing")}>Sourcing</Link>
              <Link to="/production" onClick={toggleMenu} style={getMobileLinkStyle("/production")}>Production</Link>
              <Link to="/careers" onClick={toggleMenu} style={getMobileLinkStyle("/careers")}>Careers</Link>
              <Link to="/blog" onClick={toggleMenu} style={getMobileLinkStyle("/blog")}>Blog</Link>
              <Link to="/contact" onClick={toggleMenu} style={getMobileLinkStyle("/contact")}>Contact</Link>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};